<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">اسم الباقة - عربي:</label>
          <div>{{ title }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label english-input">اسم الباقة - انجليزي:</label>
          <div>{{ titleEn }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">السعر:</label>
          <div>{{ price }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحالة:</label>
          <div>{{ (isActive)? 'نشط' : 'غير نشط' }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: 'PhotoPackagesView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: null,
      titleEn: null,
      price: 0,
      isActive: true,
    }
  },
  created(){
    if(this.dataRow){
      this.title = this.dataRow.title;
      this.titleEn = this.dataRow.titleEn;
      this.price = this.dataRow.price;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
